import PropTypes from 'prop-types';

import { TrlFormattedNumberPlain } from '»utils/i18n';
import { TrlNumberFormatted } from '»utils/number';

import { TableFooterCell } from './TrlFooterCell.styles';

export const TrlFooterCell = (props) => {
  const { colSpan, field, style, data, column } = props;
  const total = data.reduce((acc, current) => acc + (current[field] ?? 0), 0);
  const { type } = column;
  switch (type?.toUpperCase()) {
    case 'NUMERIC': {
      const decimalDigits = 2;

      return (
        <TableFooterCell
          {...props}
          colSpan={colSpan}
          style={{ textAlign: 'right' }}
          title={
            total ? TrlFormattedNumberPlain(total, decimalDigits) : undefined
          }
        >
          <TrlNumberFormatted value={total} decimalDigits={decimalDigits} />
        </TableFooterCell>
      );
    }
    default:
      return (
        <TableFooterCell {...props} colSpan={colSpan} style={style}>
          {total}
        </TableFooterCell>
      );
  }
};
TrlFooterCell.propTypes = {
  colSpan: PropTypes.number,
  field: PropTypes.string,
  style: PropTypes.any,
  data: PropTypes.array,
  column: PropTypes.object,
};
